export default "__VITE_ASSET__9dd9b094__"